const isValidPreviousEmployer = (data: Record<string, any>) => {
  return Object.entries(data || {}).some(
    ([key, value]) => key !== "secondjob" && value !== undefined && value !== ""
  );
};
export { isValidPreviousEmployer };
